// extracted by mini-css-extract-plugin
module.exports = {"content":"content__FXGsW","titleHead":"titleHead__sxRrJ"};